/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import { Fragment } from 'react';

// Component imports
import { t } from 'i18next';
import { Divider, Form, Input, InputNumber, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

// Constant declarations
const { Text } = Typography;

const LuisProviderForm = () => {
  return (
    <Fragment>
      <Divider orientation="left" className="mb-8">
        <Text type="secondary" className="fs-base">{t('Provider Settings')}</Text>
      </Divider>

      <Form.Item
        label={t('App ID')}
        name="appId"
        rules={[{
          required: true,
          type: 'string',
          whitespace: true
        }]}
      >
        <Input placeholder={t('Enter the application ID')} />
      </Form.Item>

      <Form.Item
        label={t('App Name')}
        name="appName"
        rules={[{
          required: true,
          type: 'string',
          whitespace: true
        }]}
      >
        <Input placeholder={t('Enter the application name')} />
      </Form.Item>

      <Form.Item
        label={t('Authoring Key')}
        name="authoringKey"
        rules={[{
          required: true,
          type: 'string',
          whitespace: true
        }]}
      >
        <Input placeholder={t('Enter the authoring key')} />
      </Form.Item>

      <Form.Item
        label={t('App Version')}
        name="appVersion"
        rules={[{
          required: true,
          type: 'string',
          whitespace: true
        }]}
      >
        <Input placeholder={t('Enter the application version')} />
      </Form.Item>

      <Form.Item
        label={t('Host')}
        name="host"
        rules={[{
          required: true,
          type: 'string',
          whitespace: true
        }]}
      >
        <Input placeholder={t('Enter the host')} />
      </Form.Item>

      <Form.Item
        label={t('Prediction host')}
        name="predictionHost"
        rules={[{
          required: true,
          type: 'string',
          whitespace: true
        }]}
      >
        <Input placeholder={t('Enter the prediction host')} />
      </Form.Item>

      <Form.Item
        label={t('Prediction key')}
        name="predictionKey"
        rules={[{
          required: true,
          type: 'string',
          whitespace: true
        }]}
      >
        <Input placeholder={t('Enter the prediction key')} />
      </Form.Item>
    </Fragment>
  );
};

const LuisProviderConfigurationForm = () => {
  return (
    <Form.Item
      label={t('Threshold')}
      name="predictionConfidenceThreshold"
      tooltip={{
        title: t('Threshold value for the confidence score. If the returned value is less than the threshold value, then the Default Flow will be triggered.'),
        icon: <InfoCircleOutlined />
      }}
    >
      <InputNumber
        placeholder="Enter the threshold value"
        min={0}
        max={1}
        step={0.01}
        className="w-100"
      />
    </Form.Item>
  );
};
export { LuisProviderForm, LuisProviderConfigurationForm };
